__turbopack_context__.v({
  "segment": "style-module-scss-module___vUTmW__segment",
  "segmentFilled": "style-module-scss-module___vUTmW__segmentFilled",
  "track": "style-module-scss-module___vUTmW__track",
});
